import styled from 'styled-components';
import { ellipsisText } from 'Styles/styles';
import { ReactComponent as TrashIcon } from 'Images/icon-action-bar-trash.svg';
import { ReactComponent as _Error } from 'Images/error-mark.svg';
import { FaPlus } from 'react-icons/fa';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 20px 26px 20px;
  background-color: ${({ theme }) => theme.backgrounds.detailModalFields};
`;
Wrapper.displayName = 'Wrapper';

export const TrashWrapper = styled.div`
  margin-left: auto;
  padding-left: 20px;
  opacity: 0;
`;

export const DataContainer = styled.div`
    background: ${({ theme, showGradient, expanded }) =>
        showGradient && expanded
            ? `linear-gradient(
                to bottom,
                ${theme.backgrounds.modal} 0%,       
                ${theme.backgrounds.modal} 33.33%,  
                ${theme.backgrounds.modal4} 33.33%,   
                ${theme.backgrounds.modal4} 66.66%,   
                ${theme.backgrounds.modal} 66.66%,  
                ${theme.backgrounds.modal} 100%

            )`
            : theme.backgrounds.modal};
    box-shadow: ${({ theme }) => theme.shadows.standardDropdown};
    overflow-y: auto;
    min-height: ${({ expanded }) => expanded && '110px'};
    max-height: 110px;
`;
DataContainer.displayName = 'DataContainer';

export const DataItem = styled.div`    
    font-size: 13px;
    color: ${({ theme }) => theme.textfield.text};
    cursor: pointer;
    padding: 0 14px;
    height: 36.6px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${(props) => (props.isOdd ? props.theme.backgrounds.modal4 : props.theme.backgrounds.modal)};

    &:hover{
      background-color: ${({ theme }) => theme.backgrounds.inputsFocus};
      font-weight: 500;

      & ${TrashWrapper}{
        opacity: 1;
      }
  }
`;
DataItem.displayName = 'DataItem';

export const Placeholder = styled.a`
  text-align: left;
  font-size: 13.5px;
  line-height: 2.52;
  margin-right: auto;
  ${ellipsisText}
`;
Placeholder.displayName = 'Placeholder';

export const InputComp = styled.input`
  width: 100%;
  height: 100%;
  border-style: solid;
  border-color: transparent;
  border-width: 1px 1px 0px 1px;
  background-color: ${({ theme }) => theme.textfield.background};
  padding-left: 15px;
  padding-right: 42px;
  font-weight: 300 !important;
  margin-bottom: 2px;
  color: ${({ theme }) => theme.textfield.text};
  box-shadow: ${({ theme }) => theme.shadows.inputs};
  
  &.full{
    background-color: ${({ theme }) => theme.textfield.focus} !important; 
  }

  &.responsive {
      width:100%;
  }

  &::placeholder {
    color: ${({ theme }) => theme.text.placeholder} !important;
    font-size: 13.5px;
  }

  &:hover{
    border-style: solid;
    border-width: 1px 1px 0px 1px;
  }

  &:focus{

    &::placeholder {
        color: transparent;
    }
  }

  ${({ disabled }) => disabled && 'cursor: not-allowed'};
`;
InputComp.displayName = 'InputComp';

export const Plus = styled(FaPlus)`
  position: absolute;
  right: 14px;
  top: 14px;
  height: 12px;
  width: 12px;
  cursor: pointer;
  color: #19224a;
  &:hover{
      color: white;       
  }
`;

export const PlusContainer = styled.div`
  position: absolute;
  right: 0;
  top: 0;

  width: 40px;
  height: 100%;

  background-color: ${({ theme }) => theme.textfield.backgroundIcon};

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;

  &:hover ${Plus} {
    color: white;
  }
`;

export const Trash = styled(TrashIcon)` 
    width: 16px;
    height: 17px;
    align-self: flex-end;
    g > path { 
      fill: #dc4a4a;
    }
`;

export const Error = styled.div`
  color: #ea3158;
  position: absolute;
  font-size: 10.5px;
  letter-spacing: 0.08px;
  top: 12px;
  right: 35px;
`;

export const InputWrapper = styled.div`
  height: 38px;
  position: relative;
`;

export const ErrorIcon = styled(_Error)`
  margin-right: 5px;
`;
ErrorIcon.displayName = 'ErrorIcon';
